import { ErrorBoundary } from 'react-error-boundary';
import { Toaster } from 'sonner';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom/client';
// eslint-disable-next-line import/no-extraneous-dependencies
import * as Sentry from '@sentry/react';
import App from './App';
import './index.css';
import store from './redux/store';
import Error from './pages/Error';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets:
      import.meta.env.VITE_SENTRY_TRACE_PROPAGATION_TARGETS.split(','),
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ErrorBoundary FallbackComponent={Error}>
    <Provider store={store}>
      <React.StrictMode>
        <App />
        <Toaster position="top-right" duration={1000} richColors />
      </React.StrictMode>
    </Provider>
  </ErrorBoundary>
);
